import { createSignal } from '@verclam/pulsar';

/**
 * `null` closes the sheet; `'interviews'` / `'documents'` opens it on that tab; `{ replacesDocumentTypeId }`
 * opens it on the documents of that type only, to choose the one the preparation carries over.
 */
type AddFromDossierSheetTarget =
	| 'interviews'
	| 'documents'
	| { readonly replacesDocumentTypeId: number }
	| null;

const addFromDossierSheetSignal = createSignal<AddFromDossierSheetTarget>(null);

export const openAddFromDossierSheet = (target: Exclude<AddFromDossierSheetTarget, null>): void => {
	addFromDossierSheetSignal.value = target;
};

export const closeAddFromDossierSheet = (): void => {
	addFromDossierSheetSignal.value = null;
};

export default addFromDossierSheetSignal;
